import React, { Component } from 'react';
import { GraingerAccountContext } from '../../Context/Context';

import './Team.scss'
import { Row, Column } from '../../Components/Grid/Grid'
import Page from '../../Components/Page/Page'
import Staff from '../../Components/Staff/Staff'

class Team extends Component {
  constructor(props) {
    super(props);

    this.state = {
    }
  }

  render() {
    return (
      <Page title='Our Team' type='Banner'>
        <Row className='team-container centre'>
          <Column className='team-column' flex={false}>
            <Staff
              name='Terry Grainger'
              role='Accountant &amp; Partner'
            />
            <Staff
              name='Ingrid de Chélard'
              role='Business Accountant'
            />
          </Column>
          <Column className='team-column' flex={false}>
            <Staff
              name='Tee Duong'
              role='Superfund Accountant'
            />
            <Staff
              name='Matthew Grainger'
              role='Tax Accountant'
            />
          </Column>
        </Row>
      </Page>
    );
  }
}

Team.contextType = GraingerAccountContext;
export default Team;